module.exports = __webpack_public_path__ + "images/manycai.f44a.png";